const authors = [
  {
    name: "Neha Jaspal",
    title: "Product Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/perspectives-neha-jaspal-avatar.jpg",
  },
  {
    name: "Lydia Koehn",
    title: "Staff Content Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/perspectives-lydia-kehn-avatar.jpg",
  },
  {
    name: "Jaden Nethercott",
    title: "Staff Product Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/perspectives-jaden-nethercott-avatar.jpg",
  },
  {
    name: "Barbara Kofler",
    title: "Sr. Content Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/perspectives-barbara-kofler-avatar.jpg",
  },
  {
    name: "Alex Altman",
    title: "Sr. Manager, Content Design",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/alex-altman-avatar.jpg",
  },
  {
    name: "Elly Dominicis",
    title: "Staff UX Researcher",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/elly-dominicis-avatar.jpg",
  },
  {
    name: "Elvis Benicio",
    title: "Sr. Staff Product Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/elvis-benicio-avatar.jpg",
  },
  {
    name: "Esmerly Simé Segura",
    title: "Sr. Product Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/esmerly-sime-segura-avatar.jpg",
  },
  {
    name: "Jacqueline Tye",
    title: "Sr. Director, Head of UX Research",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/jacqueline-tye-avatar.jpg",
  },
  {
    name: "Kate Walker",
    title: "Staff Content Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/kate-walker-avatar.jpg",
  },
  {
    name: "Patricia Mo",
    title: "Staff Product Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/patricia-mo-avatar.jpg",
  },
  {
    name: "Ruoxi Wang",
    title: "Product Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/ruoxi-wang-avatar.jpg",
  },
  {
    name: "Julian Body",
    title: "Product Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/julian-body-avatar.jpg",
  },
  {
    name: "Maryana Kuznetsova",
    title: "Manager, Product Design",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/maryana-kuznetsova-avatar.jpg",
  },
  {
    name: "Michael Kanne",
    title: "Sr. Staff Design Architect",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/michael-kanne-avatar.jpg",
  },
  {
    name: "Nick Inchausti",
    title: "Lead User Research for Collectibles",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/nick-inchausti-avatar.jpg",
  },
  {
    name: "Breckelle Zheng",
    title: "UX Researcher",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/breckelle-zheng-avatar.jpg",
  },
  {
    name: "Natalia Maria Flores",
    title: "Director of UX Research",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/natalia-maria-flores-avatar.jpg",
  },
  {
    name: "Ariel Duong",
    title: "Staff Visual Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/ariel-duong-avatar.jpg",
  },
  {
    name: "Elise Zimbardo-Ensor",
    title: "Staff Program Manager",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/elise-zimbardo-ensor-avatar.jpg",
  },
  {
    name: "Gabriel Rocha",
    title: "Sr. Staff Motion Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/gabriel-rocha-avatar.jpg",
  },
  {
    name: "JD Corr",
    title: "Sr. Staff Design Technologist",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/jd-corr-avatar.jpg",
  },
  {
    name: "Kyra Lee",
    title: "Content Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/kyra-lee-avatar.jpg",
  },
  {
    name: "Larissa Scordato",
    title: "Sr. Staff Design Program",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/larissa-scordato-avatar.jpg",
  },
  {
    name: "Lydia Koehn",
    title: "Staff Content Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/lydia-koehn-avatar.jpg",
  },
  {
    name: "Rachel Julius",
    title: "Staff Content Designer",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/rachel-julius-avatar.jpg",
  },
  {
    name: "Shannon Whiteman",
    title: "Staff Design Program Manager",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/shannon-whiteman-avatar.jpg",
  },
  {
    name: "Stephen Scaff",
    title: "Sr. Manager, Design Technology",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/stephen-scaff-avatar.jpg",
  },
];

const defaultAuthor: Author = {
  name: "John Smith",
  title: "Sr. Product Designer",
  src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/default-avatar.png",
};

type Author = (typeof authors)[number];

function getAuthorByName(name: string): Author {
  return authors.find((a) => a.name.trim() === name.trim()) ?? defaultAuthor;
}

export { authors, getAuthorByName, type Author };
